import React from 'react';
import styled from 'styled-components';

import AnswersFill from '@ad-scripts/presentation/components/common/icons/fill/answers-fill';
import EmojiPickerFill from '@ad-scripts/presentation/components/common/icons/fill/emoji-picker-fill';
import HelpFill from '@ad-scripts/presentation/components/common/icons/fill/help-fill';
import {
  StyledLink,
  StyledCardIcon,
  StyledColumnSecondary,
  ExternalLink,
  StyledColumnDescription,
} from 'src/presentation/components/pages/home/elements';

const NonAdminContent = () => (
  <StyledContainer>
    <StyledColumnSecondaryLink href="https://help.gladly.com/docs/whats-new" target="_blank">
      <StyledCardIcon>
        <EmojiPickerFill />
      </StyledCardIcon>
      <ExternalLink />
      <b>See what’s new</b>
      <StyledColumnDescription>
        Read the release notes to learn about new features and improvements.
      </StyledColumnDescription>
    </StyledColumnSecondaryLink>
    <StyledColumnSecondaryLink href="https://help.gladly.com" target="_blank">
      <StyledCardIcon>
        <HelpFill />
      </StyledCardIcon>
      <ExternalLink />
      <b>Your questions, answered</b>
      <StyledColumnDescription>Visit our Help Docs to troubleshoot product issues on your own.</StyledColumnDescription>
    </StyledColumnSecondaryLink>
    <StyledColumnSecondaryLink href="https://academy.gladly.com" target="_blank">
      <StyledCardIcon>
        <AnswersFill />
      </StyledCardIcon>
      <ExternalLink />
      <b>Learn new skills</b>
      <StyledColumnDescription>
        Enroll in Gladly Academy to read up on tutorials and best practices.
      </StyledColumnDescription>
    </StyledColumnSecondaryLink>
  </StyledContainer>
);

const StyledColumnSecondaryLink = styled.a`
  ${StyledColumnSecondary}
`;

const StyledContainer = styled.div`
  margin-top: 24px;
  ${StyledColumnSecondaryLink} {
    border-radius: 8px;
    border: 1px solid ${p => p.theme.colors.gray300};
    margin-bottom: 16px;
    padding: 24px 24px 24px 88px;
    cursor: pointer;

    &:last-child {
      margin-bottom: 0;
    }

    ${StyledCardIcon} {
      display: flex;
    }

    &:hover {
      background-color: ${p => p.theme.colors.gray100};
    }
    &:active {
      background-color: ${p => p.theme.colors.gray500};
    }
  }

  ${StyledLink} {
    display: none;
  }

  ${ExternalLink} {
    display: block;
  }

  b {
    font-size: 16px;
  }
`;

export default NonAdminContent;
